import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes.js'
import { setupNavigationGuards } from './guards.js'

const router = createRouter({
  history: createWebHistory(),
  routes
})

setupNavigationGuards(router)

export default router
